import React, {} from "react";
import styles from "./Button.module.css";

export default function Button(props) {

    return (
        <div
            className={styles.root}
            style={props.style}
            onClick={() => props.onClick ? props.onClick() : null}>
            {props.label}
            {props.children}
        </div>
    )
}